{{extend './form_line.art'}}
{{block 'line'}}
<textarea name="{{ attr.name }}" id="{{ attr.name }}"{{if attr.other}} {{@ attr.other}}{{/if}}>{{if (data.value)}}{{data.value}}{{/if}}</textarea>
{{/block}}